import { Injectable, inject } from '@angular/core';
import { UIRouter } from '@uirouter/angular';
import { SlidesStateNames } from '../../router/slides-states';

@Injectable({
  providedIn: 'root',
})
export class MenuService {
  private uiRouter = inject(UIRouter);

  getSlideSates() {
    const slideStates = this.uiRouter.stateService.get()?.filter(x => {
      if (x.name == SlidesStateNames.SlidesParent) return false;
      if (!x.name.startsWith(SlidesStateNames.SlidesParent)) return false;

      const stateNameWithoutParent = x.name.substring(SlidesStateNames.SlidesParent.length, x.name.length);

      const parts = stateNameWithoutParent.split('.').filter(x => x);
      const isValid = parts.length <= 1;

      return isValid;
    });

    slideStates.sort((s1, s2) => {
      return s1.data.order - s2.data.order;
    });

    return slideStates;
  }
}
